module.exports = __webpack_public_path__ + "img/IND-i-1-III.a9f7c1fa.png";